module.exports = __webpack_public_path__ + "static/media/(H)-Artesanato-12.44b3dae6.jpg";